<template>
  <div
    ref="barChart"
    :style="{
      'width': options.config.width,
      'height': options.config.height
    }"
  />
</template>
<script>
// 引入主模块
import echarts from 'echarts/lib/echarts'
// 引入柱状图组件
import 'echarts/lib/chart/bar'
// 配置项
import barConfig from './echarts-config/bar'
import 'echarts/lib/component/tooltip'
import mixin from './charts-mixin/chartsMixin'

export default {
  name: 'BarChart',
  mixins: [mixin],
  props: {
    options: {
      required: true,
      type: Object
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    echarts.dispose(this.$echarts)
  },
  methods: {
    init () {
      this.$echarts && echarts.dispose(this.$echarts)
      this.$echarts = echarts.init(this.$refs.barChart)
      // 获取配置
      let option = barConfig.getOptions(this.options.data, this.options.config)
      this.$echarts.setOption(option)
    }
  }
}
</script>
